module.exports = __webpack_public_path__ + "img/wz-9-1.e9cf5839.png";